import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import AppProvider from './hooks';
import { Routes } from './routes';
import GlobalStyle from './styles/global';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AppProvider>
        <ToastContainer />

        <Routes />
      </AppProvider>
      <GlobalStyle />
    </BrowserRouter>
  );
};

export default App;
